import { Badge } from '@/components/ui/badge';
import changingDiaper from '@/assets/changing-diaper.mp4';

export const ProductDemo = () => {
    return (
        <section className="relative w-full bg-pink-50/70" style={{ zIndex: 5 }}>
            {/* Curved divider */}
            <div className="absolute top-0 left-0 right-0 h-16 bg-white" style={{ borderRadius: '0 0 50% 50%/100px' }}></div>
            
            {/* Background with pattern */}
            <div className="w-full pt-24 pb-24" style={{ 
                background: 'linear-gradient(135deg, rgba(122, 134, 216, 0.07), rgba(138, 107, 214, 0.07))',
                backgroundImage: 'radial-gradient(circle at 20px 20px, rgba(138, 107, 214, 0.05) 2px, transparent 0), linear-gradient(135deg, rgba(122, 134, 216, 0.07), rgba(138, 107, 214, 0.07))',
                backgroundSize: '40px 40px, 100% 100%'
            }}>
                <div className="container mx-auto px-4">
                    <div className="text-center mb-16">
                        <Badge className="mb-4 bg-gradient-to-r from-destructive/10 to-warning/10 text-destructive hover:from-destructive/15 hover:to-warning/15 font-medium px-4 py-2">
                            See It In Action
                        </Badge>
                        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">
                            How BerryBabies Works
                        </h2>
                        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                            Watch our quick demo to see how easy it is to use the Berry sensor
                        </p>
                    </div>
                </div>
                
                {/* Full width video container with design elements */}
                <div className="relative w-full max-w-5xl mx-auto">
                    <div className="absolute -inset-1 rounded-2xl bg-gradient-to-r from-primary via-secondary to-accent opacity-30 blur-xl"></div>
                    <div className="relative mx-4 shadow-2xl rounded-2xl overflow-hidden border-8 border-white dark:border-gray-800">
                        <video 
                            controls
                            poster="/logo.png"
                            className="w-full aspect-video object-cover block"
                            style={{ maxHeight: "80vh" }}
                        >
                            <source src={changingDiaper} type="video/mp4" />
                        </video>
                    </div>
                    
                    {/* Decorative element */}
                    <div className="absolute -bottom-8 -right-8 w-20 h-20 rounded-full bg-gradient-to-br from-secondary to-accent opacity-70 blur-xl"></div>
                    <div className="absolute -top-8 -left-8 w-16 h-16 rounded-full bg-gradient-to-br from-primary to-secondary opacity-70 blur-xl"></div>
                </div>
            </div>
            
            {/* Bottom curve */}
            <div className="absolute bottom-0 left-0 right-0 h-16 bg-white" style={{ borderRadius: '50% 50% 0 0/100px' }}></div>
        </section>
    );
};